import { types as sdkTypes } from '../util/sdkLoader';

const { LatLng, LatLngBounds } = sdkTypes;

// An array of locations to show in the LocationAutocompleteInput when
// the input is in focus but the user hasn't typed in any search yet.
//
// Each item in the array should be an object with a unique `id` (String) and a
// `predictionPlace` (util.types.place) properties.
//
// NOTE: these are highly recommended, since they
//       1) help customers to find relevant locations, and
//       2) reduce the cost of using map providers geocoding API
const defaultLocations = [
  {
    id: 'default-new-york',
    predictionPlace: {
      address: 'New York, New York',
      bounds: new LatLngBounds(new LatLng(40.917577, -73.700272), new LatLng(40.477399, -74.25909)),
    },
  },
  {
    id: 'default-los-angeles',
    predictionPlace: {
      address: 'Los Angeles, California',
      bounds: new LatLngBounds(new LatLng(34.337306, -118.155289), new LatLng(33.703652, -118.668176)),
    },
  },
  {
    id: 'default-chicago',
    predictionPlace: {
      address: 'Chicago, Illinois',
      bounds: new LatLngBounds(new LatLng(42.023131, -87.524081), new LatLng(41.644531, -87.940101)),
    },
  },
  {
    id: 'default-houston',
    predictionPlace: {
      address: 'Houston, Texas',
      bounds: new LatLngBounds(new LatLng(30.110732, -95.014496), new LatLng(29.523624, -95.789623)),
    },
  },
  {
    id: 'default-philadelphia',
    predictionPlace: {
      address: 'Philadelphia, Pennsylvania',
      bounds: new LatLngBounds(new LatLng(40.137992, -74.955755), new LatLng(39.867004, -75.280266)),
    },
  },
  {
    id: 'default-san-antonio',
    predictionPlace: {
      address: 'San Antonio, Texas',
      bounds: new LatLngBounds(new LatLng(29.734968, -98.294838), new LatLng(29.183434, -98.784927)),
    },
  },
  {
    id: 'default-san-diego',
    predictionPlace: {
      address: 'San Diego, California',
      bounds: new LatLngBounds(new LatLng(33.114249, -116.908307), new LatLng(32.534856, -117.292001)),
    },
  },
  {
    id: 'default-san-francisco',
    predictionPlace: {
      address: 'San Francisco, California',
      bounds: new LatLngBounds(new LatLng(37.832371, -122.348215), new LatLng(37.703446, -122.527002)),
    },
  },
];
export default defaultLocations;
